import { BaseApiService } from './baseApi';
import type { ApiResponse } from '../../../../types';

export interface ServiceDto {
  id: string;
  slug: string;
  title_fr: string;
  title_en: string;
  description_fr?: string;
  description_en?: string;
  icon?: string;
  is_visible: boolean;
  order_index: number;
  created_at?: string;
  updated_at?: string;
}

class ServicesApi extends BaseApiService {
  constructor() {
    super('/services');
  }

  // Public
  async listPublic(): Promise<ServiceDto[]> {
    const res = await this.requestGet<{ success: boolean; data: ServiceDto[] }>('/', false);
    if (res?.data && Array.isArray((res as any).data)) {
      return (res as any).data;
    }
    return [];
  }

  async getBySlug(slug: string): Promise<ServiceDto | null> {
    const res = await this.requestGet<{ success: boolean; data: ServiceDto }>(`/slug/${encodeURIComponent(slug)}`, false);
    return (res as any).data || null;
  }

  // Admin
  async listAll(): Promise<ServiceDto[]> {
    const res = await this.requestGet<{ success: boolean; data: ServiceDto[] }>(`/admin`, true);
    return (res as any).data || [];
  }

  async create(payload: Partial<ServiceDto>): Promise<ApiResponse<ServiceDto>> {
    return await this.requestPost<ServiceDto>('/', payload, true);
  }

  async update(id: string, payload: Partial<ServiceDto>): Promise<ApiResponse<ServiceDto>> {
    return await this.requestPut<ServiceDto>(`/${id}`, payload, true);
  }

  async remove(id: string): Promise<boolean> {
    const res = await this.requestDelete<boolean>(`/${id}`, true);
    return !!res.success;
  }

  async reorder(items: Array<{ id: string; order_index: number }>): Promise<boolean> {
    const res = await this.requestPost<unknown>('/reorder', { items }, true);
    return !!res.success;
  }
}

export const servicesApi = new ServicesApi();
export default servicesApi;
